
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("67dbC", function(module, exports) {

$parcel$export(module.exports, "showStorySimulationModal", () => $473da011ecf32881$export$6a524ea08c11c1a0);
$parcel$export(module.exports, "advancePhase", () => $473da011ecf32881$export$71a449eb0c78ba1e);
$parcel$export(module.exports, "generateFinalStory", () => $473da011ecf32881$export$8e21d288b86f3716);
// frontend/js/storySimulation.js - Story Simulation Entry and Session Management

var $cNeIB = parcelRequire("cNeIB");

var $fUPn2 = parcelRequire("fUPn2");
function $473da011ecf32881$export$6a524ea08c11c1a0() {
    // First show the Catena Narrativa introduction
    $473da011ecf32881$var$showCatenaIntroduction();
}
/**
 * Show Catena Narrativa Introduction Modal
 * Explains the concept before story selection
 */ function $473da011ecf32881$var$showCatenaIntroduction() {
    const modal = document.createElement('div');
    modal.classList.add('story-modal');
    modal.innerHTML = `
   <div class="story-modal-content catena-intro">
     <h1>${(0, $fUPn2.t)('story.catena_title', 'Catena Narrativa')}</h1>

     <div class="intro-section">
       <p class="subtitle">
         <em>${(0, $fUPn2.t)('story.catena_subtitle', 'Story building as supply chains: trade, customize, and consolidate through three phases to complete the story creation process.')}</em>
       </p>

       <button id="continueToCatena" class="primary-btn">
         Continue to Story Selection
       </button><br>

       <h3>${(0, $fUPn2.t)('story.process_heading', 'Process:')}</h3>
       <ul>
         <li><strong>${(0, $fUPn2.t)('story.materials_motion_title', 'Materials in motion:')}</strong> ${(0, $fUPn2.t)('story.materials_motion_desc', 'Trade narrative elements as commodities. Customizing them as you trade. Value forms through the exchanging process to construct a story.')}</li>
         <li><strong>${(0, $fUPn2.t)('story.three_passes_title', 'Three passes:')}</strong> ${(0, $fUPn2.t)('story.three_passes_desc', "Origin (beginning) \u2192 Transit (middle) \u2192 Assembly (end) ( 3min + 3min + 2min \u22488 minutes total). Each phase ends after the time expires, or you redeem, resulting in your bullet point commodities being secured into a personal story ledger.")}</li>
         <li><strong>${(0, $fUPn2.t)('story.composition_title', 'Composition:')}</strong> ${(0, $fUPn2.t)('story.composition_desc', 'At the end, your ledger is transformed into a short story generated from your customized trading of assets and redeemed secured bullet points.')}</li>
       </ul>

       <p>
         <strong>${(0, $fUPn2.t)('story.commodity_x_label', 'Commodity X')} <em>${(0, $fUPn2.t)('story.catena_title', 'Catena Narrativa')}</em></strong>: ${(0, $fUPn2.t)('story.commodity_x_desc', "is part of ZEconomy where profits are measured in <strong>Life Profit</strong>\u2014 the quality and quantity of intellect, affection, partying... etc, all of life's divers happenings, promoting being\u2014over accumulation.")}
       </p>

       <p class="footer-note">
         ${(0, $fUPn2.t)('story.footer_note_consumption', 'Commodity X where Consumption is relational: you cannot consume without mutual assent. The commodity is not the object; the commodity is the interaction.')}<br><br>
         ${(0, $fUPn2.t)('story.footer_note_redeem', 'Redeem relationally. Consume consciously.')}
       </p>
     </div>

     <button id="closeCatenaIntro" class="secondary-btn">
       Close
     </button>
   </div>
   `;
    document.body.appendChild(modal);
    // Continue button - shows genre selection
    document.getElementById('continueToCatena').addEventListener('click', ()=>{
        modal.remove();
        $473da011ecf32881$var$showGenreSelectionModal();
    });
    // Close button - returns to index
    document.getElementById('closeCatenaIntro').addEventListener('click', ()=>{
        modal.remove();
        window.location.href = 'index.html';
    });
    // Add hover effect to continue button
    const continueBtn = document.getElementById('continueToCatena');
    continueBtn.addEventListener('mouseenter', ()=>{
        continueBtn.style.transform = 'scale(1.05)';
        continueBtn.style.boxShadow = '0 0 30px rgba(102, 102, 255, 0.8)';
    });
    continueBtn.addEventListener('mouseleave', ()=>{
        continueBtn.style.transform = 'scale(1)';
        continueBtn.style.boxShadow = '0 0 20px rgba(102, 102, 255, 0.5)';
    });
}
/**
 * Show Genre Selection Modal (original story selection)
 */ function $473da011ecf32881$var$showGenreSelectionModal() {
    const modal = document.createElement('div');
    modal.classList.add('story-modal');
    modal.innerHTML = `
    <div class="story-modal-content">
      <h2>${(0, $fUPn2.t)('story.simulation_title', 'Story Simulation')}</h2>
      <p class="intro-text">
        ${(0, $fUPn2.t)('story.simulation_intro', 'Engage in a narrative exchange with automated participants across three distinct phases, crafting a unique short story through dynamic collaboration.')}
      </p>

      <div class="genre-section">
        <h3>${(0, $fUPn2.t)('story.choose_genre', 'Choose Your Genre')}</h3>
        <div id="theme-selection" class="theme-selection">
          <button class="theme-btn" data-theme="scifi">
            ${(0, $fUPn2.t)('story.genre_scifi', 'Science Fiction')} <span>${(0, $fUPn2.t)('story.genre_scifi_desc', 'Futuristic visions and speculative worlds')}</span>
          </button>
          <button class="theme-btn" data-theme="romance">
            ${(0, $fUPn2.t)('story.genre_romance', 'Romance')} <span>${(0, $fUPn2.t)('story.genre_romance_desc', 'Emotion, intimacy, and human connection')}</span>
          </button>
          <button class="theme-btn" data-theme="mystery">
            ${(0, $fUPn2.t)('story.genre_mystery', 'Mystery')} <span>${(0, $fUPn2.t)('story.genre_mystery_desc', 'Secrets, investigation, and concealed motives')}</span>
          </button>
          <button class="theme-btn" data-theme="fantasy">
            ${(0, $fUPn2.t)('story.genre_fantasy', 'Fantasy')} <span>${(0, $fUPn2.t)('story.genre_fantasy_desc', 'Myth, imagination, and transcendence')}</span>
          </button>
          <button class="theme-btn" data-theme="horror">
            ${(0, $fUPn2.t)('story.genre_horror', 'Horror')} <span>${(0, $fUPn2.t)('story.genre_horror_desc', 'Fear, suspense, and the confrontation of the unknown')}</span>
          </button>
        </div>
      </div>

      <div class="footer-section">
        <p class="duration">${(0, $fUPn2.t)('story.duration', 'Duration: 8 minutes (3 + 3 + 2 minute phases)')}</p>
        <button id="closeStoryModal" class="secondary-btn">Cancel</button>
      </div>
    </div>
  `;
    document.body.appendChild(modal);
    // Add hover effects and theme selection
    const themeButtons = modal.querySelectorAll('.theme-btn');
    themeButtons.forEach((btn)=>{
        btn.addEventListener('mouseenter', ()=>{
            btn.style.transform = 'scale(1.05)';
            btn.style.boxShadow = '0 0 20px rgba(102, 102, 255, 0.5)';
        });
        btn.addEventListener('mouseleave', ()=>{
            btn.style.transform = 'scale(1)';
            btn.style.boxShadow = 'none';
        });
        btn.addEventListener('click', async ()=>{
            const theme = btn.dataset.theme;
            modal.remove();
            await $473da011ecf32881$var$showItemSelection(theme);
        });
    });
    document.getElementById('closeStoryModal').addEventListener('click', ()=>{
        modal.remove();
    });
}
/**
 * Show item selection modal
 */ async function $473da011ecf32881$var$showItemSelection(theme) {
    const loadingModal = document.createElement('div');
    loadingModal.classList.add('modal');
    loadingModal.style.cssText = `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background: rgba(0, 0, 0, 0.95) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 10002 !important;
  `;
    loadingModal.innerHTML = `
    <div class="modal-content" style="
      background: #000;
      color: #66ffff;
      padding: 40px;
      border-radius: 15px;
      text-align: center;
      border: 2px solid #6666ff;
    ">
      <h2 style="margin-bottom: 20px;">${(0, $fUPn2.t)('story.loading_elements', ' Loading Story Elements...')}</h2>
      <div style="
        width: 50px;
        height: 50px;
        border: 4px solid rgba(102, 102, 255, 0.3);
        border-top-color: #6666ff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 20px auto;
      "></div>
    </div>
  `;
    document.body.appendChild(loadingModal);
    try {
        // Fetch available items
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/storysim/available-items/${theme}`);
        if (!response.ok) throw new Error('Failed to fetch items');
        const data = await response.json();
        loadingModal.remove();
        // Show selection modal
        $473da011ecf32881$var$showItemSelectionModal(theme, data.items);
    } catch (error) {
        loadingModal.remove();
        console.error("\u274C [StorySimulation] Error fetching items:", error);
        window.alert(`${(0, $fUPn2.t)('story.failed_load_elements', 'Failed to load story elements')}: ${error.message}`);
    }
}
/**
 * Show item selection modal with available items
 */ function $473da011ecf32881$var$showItemSelectionModal(theme, items) {
    const modal = document.createElement('div');
    modal.classList.add('modal', `item-modal-${theme}`);
    modal.style.cssText = `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background: rgba(0, 0, 0, 0.95) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 10002 !important;
    overflow-y: auto !important;
  `;
    const itemsHTML = items.map((item)=>`
    <div class="item-card" data-item-id="${item.itemId}">
      <div class="item-card-title">
        ${item.name}
      </div>
      <div class="item-card-base">
        <strong>${item.baseElement}</strong>
      </div>
      <div class="item-card-description">
        ${item.description}
      </div>
    </div>
  `).join('');
    modal.innerHTML = `
    <div class="modal-content" style="
      color: #fff;
      padding: 30px;
      border-radius: 15px;
      max-width: 600px;
      max-height: 80vh;
      overflow-y: auto;
    ">
      <h2 style="margin-bottom: 15px; font-size: 1.5em;">
        ${(0, $fUPn2.t)('story.choose_starting_element', 'Choose Your Starting Element')}
      </h2>
      <p style="color: #ccc; margin-bottom: 20px; line-height: 1.5;">
        ${(0, $fUPn2.t)('story.select_one_element', "Select one story element to begin with. You'll also receive 2 random elements.")}
      </p>
      <div id="items-list" style="margin-bottom: 20px;">
        ${itemsHTML}
      </div>
      <button id="skipSelection" style="
        background: rgba(255, 255, 255, 0.1);
        color: #ccc;
        border: 1px solid #666;
        padding: 12px 30px;
        border-radius: 8px;
        cursor: pointer;
        font-size: 1em;
        width: 100%;
      ">
        Skip Selection (Get 3 Random Elements)
      </button>
    </div>
  `;
    document.body.appendChild(modal);
    // Add click handlers
    const itemCards = modal.querySelectorAll('.item-card');
    itemCards.forEach((card)=>{
        card.addEventListener('mouseenter', ()=>{
            card.style.transform = 'scale(1.02)';
        });
        card.addEventListener('mouseleave', ()=>{
            card.style.transform = 'scale(1)';
        });
        card.addEventListener('click', ()=>{
            const itemId = card.dataset.itemId;
            modal.remove();
            $473da011ecf32881$var$createStorySession(theme, itemId);
        });
    });
    document.getElementById('skipSelection').addEventListener('click', ()=>{
        modal.remove();
        $473da011ecf32881$var$createStorySession(theme, null);
    });
}
/**
 * Create story simulation session
 */ async function $473da011ecf32881$var$createStorySession(theme, selectedItemId = null) {
    const loadingModal = document.createElement('div');
    loadingModal.classList.add('modal');
    loadingModal.style.cssText = `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background: rgba(0, 0, 0, 0.95) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 10002 !important;
  `;
    loadingModal.innerHTML = `
    <div class="modal-content" style="
      background: #000;
      color: #66ffff;
      padding: 40px;
      border-radius: 15px;
      text-align: center;
      border: 2px solid #6666ff;
    ">
      <h2 style="margin-bottom: 20px;">${(0, $fUPn2.t)('story.preparing_story', ' Preparing Your Story...')}</h2>
      <p style="color: #ccc;">${(0, $fUPn2.t)('story.setting_up_simulation', 'Setting up {theme} simulation...').replace('{theme}', theme)}</p>
      <div style="
        width: 50px;
        height: 50px;
        border: 4px solid rgba(102, 102, 255, 0.3);
        border-top-color: #6666ff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 20px auto;
      "></div>
    </div>
  `;
    document.body.appendChild(loadingModal);
    try {
        const preferredLanguage = localStorage.getItem('preferredLanguage') || 'en';
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/sim/create-story-session`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                theme: theme,
                preferredLanguage: preferredLanguage,
                selectedItemId: selectedItemId
            })
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to create session');
        }
        const result = await response.json();
        // Store session data AND authentication data
        localStorage.setItem('portfolioId', result.portfolioId); // CRITICAL: Store portfolioId
        localStorage.setItem('token', result.token); // CRITICAL: Store token
        localStorage.setItem('sessionId', result.sessionId);
        localStorage.setItem('simulationInstanceId', result.simulationInstanceId); // Pool ID
        localStorage.setItem('role', result.role || 'user'); // User role
        localStorage.setItem('storyTheme', result.theme);
        localStorage.setItem('storyPhase', result.currentPhase);
        localStorage.setItem('storyPhaseEndsAt', result.phaseEndsAt);
        localStorage.setItem('simulationType', 'story-simulation');
        localStorage.setItem('isSimulated', 'true');
        console.log("\u2705 [StorySimulation] Session created:", result);
        loadingModal.innerHTML = `
      <div class="modal-content" style="
        background: #000;
        color: #00ff00;
        padding: 40px;
        border-radius: 15px;
        text-align: center;
      ">
        <h2 style="color: #00ff00; margin-bottom: 20px;">${(0, $fUPn2.t)('story.story_begins', ' Story Begins Now')}</h2>
        <p style="color: #ccc;">${(0, $fUPn2.t)('story.entering_world', 'Entering {theme} world in 2 seconds...').replace('{theme}', theme)}</p>
      </div>
    `;
        setTimeout(()=>{
            loadingModal.remove();
            window.location.href = 'zfloor.html';
        }, 2000);
    } catch (error) {
        loadingModal.remove();
        console.error("\u274C [StorySimulation] Session creation error:", error);
        window.alert(`${(0, $fUPn2.t)('story.failed_create_session', 'Failed to create story session')}: ${error.message}`);
    }
}


async function $473da011ecf32881$export$a354329df9ca0bbf() {
    const simulationType = localStorage.getItem('simulationType');
    console.log("\uD83D\uDCD6 [initializeStorySimulationUI] Called. SimulationType:", simulationType);
    if (simulationType !== 'story-simulation') {
        console.log("\u26A0\uFE0F [initializeStorySimulationUI] Not story-simulation mode, exiting");
        return;
    }
    const theme = localStorage.getItem('storyTheme');
    const phase = localStorage.getItem('storyPhase');
    console.log(`\u{1F4D6} [initializeStorySimulationUI] Theme: ${theme}, Phase: ${phase}`);
    // Add body class for CSS-based hiding (follows mementoMori pattern)
    document.body.classList.add('story-simulation-mode');
    // Hide non-story elements in story simulation
    const elementsToHide = [
        // Emotional Debt Index and Instruments
        'emotional-state-banner',
        'emotional-debt-meter',
        'social-economy-banner',
        'social-economy-actions',
        // Tools section
        'tools-banner',
        'messageButton',
        'steal-button-container',
        'ransom-button-container',
        'community-button-container',
        // Economic triggers
        'economic-banner',
        'economic-triggers-message',
        'delete-portfolio-button-container',
        'LBOButton-button-container',
        'SubsidyButton-button-container',
        // Short positions
        'shorts-banner',
        'shorted-stocks-container',
        // ZBonds
        'zbonds-banner',
        'bond-holdings'
    ];
    elementsToHide.forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.style.display = 'none';
    });
    console.log("\uD83D\uDCD6 [initializeStorySimulationUI] Hidden emotional debt elements");
    // Import and initialize bullet points display
    const { initializeStoryBulletPoints: initializeStoryBulletPoints } = await (parcelRequire("6FBkp"));
    await initializeStoryBulletPoints();
    // Import and initialize phase manager
    const { initializeStoryPhaseManager: initializeStoryPhaseManager } = await (parcelRequire("7rIYF"));
    await initializeStoryPhaseManager();
    console.log("\u2705 [initializeStorySimulationUI] Initialization complete");
}
async function $473da011ecf32881$export$320c7c562dc23bce() {
    try {
        const portfolioId = localStorage.getItem('portfolioId');
        const token = localStorage.getItem('token');
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/storysim/current-phase/${portfolioId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...token && {
                    Authorization: `Bearer ${token}`
                }
            }
        });
        if (!response.ok) throw new Error('Failed to get phase info');
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("\u274C [StorySimulation] Error getting phase:", error);
        return null;
    }
}
async function $473da011ecf32881$export$71a449eb0c78ba1e() {
    try {
        const portfolioId = localStorage.getItem('portfolioId');
        const token = localStorage.getItem('token');
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/storysim/advance-phase`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...token && {
                    Authorization: `Bearer ${token}`
                }
            },
            body: JSON.stringify({
                portfolioId: portfolioId
            })
        });
        if (!response.ok) throw new Error('Failed to advance phase');
        const data = await response.json();
        // Update localStorage
        localStorage.setItem('storyPhase', data.currentPhase);
        localStorage.setItem('storyPhaseEndsAt', data.phaseEndsAt);
        console.log(`\u{2705} [StorySimulation] Advanced to ${data.currentPhase} phase`);
        return data;
    } catch (error) {
        console.error("\u274C [StorySimulation] Error advancing phase:", error);
        return null;
    }
}
async function $473da011ecf32881$export$8e21d288b86f3716() {
    try {
        const portfolioId = localStorage.getItem('portfolioId');
        const token = localStorage.getItem('token');
        console.log("\uD83C\uDFAC [StorySimulation] Generating final story...");
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/storysim/generate-final`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...token && {
                    Authorization: `Bearer ${token}`
                }
            },
            body: JSON.stringify({
                portfolioId: portfolioId
            })
        });
        if (!response.ok) throw new Error('Failed to generate story');
        const data = await response.json();
        console.log("\u2705 [StorySimulation] Story generated:", data.storyId);
        // Store story ID
        localStorage.setItem('storyId', data.storyId);
        return data;
    } catch (error) {
        console.error("\u274C [StorySimulation] Error generating story:", error);
        return null;
    }
}
var $473da011ecf32881$export$2e2bcd8739ae039 = {
    showStorySimulationModal: $473da011ecf32881$export$6a524ea08c11c1a0,
    initializeStorySimulationUI: $473da011ecf32881$export$a354329df9ca0bbf,
    getCurrentPhase: $473da011ecf32881$export$320c7c562dc23bce,
    advancePhase: $473da011ecf32881$export$71a449eb0c78ba1e,
    generateFinalStory: $473da011ecf32881$export$8e21d288b86f3716
};

});
parcelRegister("6FBkp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5EFbR").then(()=>parcelRequire('7BbbQ'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("7rIYF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("35lbq").then(()=>parcelRequire('kKztl'));

});


var $5491167412546fe9$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1fJeI\",\"index.3b2333d1.js\",\"5EFbR\",\"storyBulletPoints.f571a23a.js\",\"35lbq\",\"storyPhaseManager.bda36eba.js\"]"));


//# sourceMappingURL=index.3b2333d1.js.map
